// src/utils/auth.js
import { jwtDecode } from "jwt-decode";

export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const { exp } = jwtDecode(token);
    return exp * 1000 > Date.now(); // Kiểm tra thời gian hết hạn
  } catch (err) {
    return false; // Token không hợp lệ
  }
};
